import { createFileRoute } from '@tanstack/react-router';
import MarketingListPage from '@/pages/marketing/marketing-list-page';

export const Route = createFileRoute('/_protected/marketing/')({
    component: MarketingListPage,
});
